var PRO_LIST_KEYS = ['title', 'subTitle', 'avatar', 'description', 'extra', 'content', 'actions', 'type'];
var PRO_LIST_KEYS_MAP = PRO_LIST_KEYS.reduce(function (pre, next) {
  pre.set(next, true);
  return pre;
}, new Map());
export { PRO_LIST_KEYS_MAP, PRO_LIST_KEYS };